define.alias("shared/components/shared/upgrade/all-features-modal", "media/components/shared/upgrade/all-features-modal");